import { render, staticRenderFns } from "./FeeInstructions.vue?vue&type=template&id=b5acb62c"
import script from "./FeeInstructions.vue?vue&type=script&lang=js"
export * from "./FeeInstructions.vue?vue&type=script&lang=js"
import style0 from "./FeeInstructions.vue?vue&type=style&index=0&id=b5acb62c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports